import { Product, UnitType } from "./types";

export const UNIT_OPTIONS: { value: UnitType; label: string }[] = [
  { value: "kilos", label: "Kilogramos (kg)" },
  { value: "cajas", label: "Cajas" },
  { value: "unidades", label: "Unidades" },
];

// NOTA: Estos productos son temporales para desarrollo
// En producción se cargarán desde el endpoint /api/products
export const PRODUCTS = [
  {
    id: "00000000-0000-0000-0000-000000000001",
    name: "Lechuga Iceberg",
    description: "Lechuga fresca y crujiente",
    isActive: true,
  },
  {
    id: "00000000-0000-0000-0000-000000000002",
    name: "Tomate Rama",
    description: "Tomate maduro de temporada",
    isActive: true,
  },
  {
    id: "00000000-0000-0000-0000-000000000003",
    name: "Calabacín Verde",
    description: "Calabacín tierno y fresco",
    isActive: true,
  },
  {
    id: "00000000-0000-0000-0000-000000000004",
    name: "Pimiento Rojo",
    description: "Pimiento dulce rojo",
    isActive: true,
  },
  {
    id: "00000000-0000-0000-0000-000000000005",
    name: "Zanahoria",
    description: "Zanahoria fresca y natural",
    isActive: true,
  },
];
